import { FormProvider } from "react-hook-form";
import styles from "./PlannerEventReservationDetailsPaymentMethodDialog.module.scss";
import { HiddenField } from "../../../../common/components/forms/inputs/hiddenField/HiddenField";
import { nameof } from "ts-simple-nameof";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { useAddPaymentTypeForm } from "../hooks/useAddPaymentTypeForm";
import { IAddPaymentTypeFormData } from "../models/addPaymentTypeFormData";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { DefaultToggle } from "../../../../common/components/forms/inputs/toggle/DefaultToggle";
import { MessageBanner } from "../../../../common/components/common/MessageBanner/MessageBanner";
import { PaymentMethodFormFields } from "../../common/PaymentMethodFormFields";

interface IPlannerEventReservationDetailsPaymentMethodDialogProps {
  userEventId: number;
  onSuccess: () => void;
  showFormCompletionCheckbox?: boolean;
}

export const PlannerEventReservationDetailsPaymentMethodDialog = ({
  userEventId,
  onSuccess,
  showFormCompletionCheckbox,
}: IPlannerEventReservationDetailsPaymentMethodDialogProps) => {
  const {
    form,
    paymentOptions,
    subscriptions,
    isLoading,
    handleSubmit,
    isSubmitting,
    onPaymentTypeUserSelect,
  } = useAddPaymentTypeForm({
    userEventId,
    onSuccess,
  });

  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit} className={styles.root}>
        <MessageBanner
          type="warning"
          message="С добавена сума, абонаментна карта или депозит резервацията се счита за платена и потребителят няма да може сам да я откаже — отказване може само от администратор. Начин на плащане без сума (напр. Мултиспорт) не пречи на отказа."
        />

        <HiddenField
          name={nameof<IAddPaymentTypeFormData>((x) => x.userEventId)}
        />

        <PaymentMethodFormFields
          fieldNames={{
            paymentTypeId: nameof<IAddPaymentTypeFormData>(
              (x) => x.paymentTypeId,
            ),
            subscriptionId: nameof<IAddPaymentTypeFormData>(
              (x) => x.subscriptionPlanId,
            ),
            price: nameof<IAddPaymentTypeFormData>((x) => x.price),
            currencyId: nameof<IAddPaymentTypeFormData>((x) => x.currencyId),
          }}
          paymentOptions={paymentOptions}
          subscriptions={subscriptions}
          paymentTypeTooltip="Изберете действителния начин, по който потребителят е платил."
          onPaymentTypeUserSelect={onPaymentTypeUserSelect}
        />

        <RenderWhen condition={showFormCompletionCheckbox === true}>
          <DefaultToggle
            name={nameof<IAddPaymentTypeFormData>((x) => x.hasFilledForm)}
            label="Потребителят е попълнил задължителния формуляр"
            tooltip="Маркирайте това поле, ако потребителят вече е попълнил задължителния формуляр за това събитие."
          />
        </RenderWhen>

        <DefaultButton
          label={"Добави"}
          type="submit"
          loading={isSubmitting || isLoading}
        />
      </form>
    </FormProvider>
  );
};
